<div class="panel panel-primary">
    @if (Loading) {
        <div class="loading"></div>
    }
    <div class="panel-heading">
        Payment
        <div class="pull-right">
            <button nz-button class="pf-form-action" (click)="Update()">
                <span class="fa-solid fa-floppy-disk"></span>Save
            </button>
        </div>
    </div>
    <div class="panel-body">
        <div class="panel panel-default">
            <div class="panel-heading">Payment Information</div>
            <div class="panel-body">
                <div class="form-horizontal" role="form">
                    <div class="form-group">
                        <div class="control-label col-md-2">Vendor Invoice #</div>
                        <div class="col-md-4">
                            <input class="form-control" type="text" [(ngModel)]="PO.VendorInvoiceNumber" />
                        </div>
                        <div class="control-label col-md-2">Reconciled?</div>
                        <div class="col-md-2">
                            <input type="checkbox" [(ngModel)]="PO.Reconciled" />
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="control-label col-md-2">Payment Date</div>
                        <div class="col-md-4">
                            <nz-date-picker
                                [(ngModel)]="PaymentDate"
                                nzFormat="MM/dd/yyyy"
                                style="width: 100%"></nz-date-picker>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="control-label col-md-2">Due Date</div>
                        <div class="col-md-4">
                            <nz-date-picker
                                [(ngModel)]="DueDate"
                                nzFormat="MM/dd/yyyy"
                                style="width: 100%"></nz-date-picker>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="control-label col-md-2">Check Number</div>
                        <div class="col-md-4">
                            <input class="form-control" type="text" maxlength="128" [(ngModel)]="PO.CheckNumber" />
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="control-label col-md-2">Payment Notes</div>
                        <div class="col-md-10">
                            <textarea
                                style="height: 200px"
                                class="form-control"
                                [(ngModel)]="PO.PaymentNotes"></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="panel-body">
            <div class="panel panel-default">
                <div class="panel-heading">Linked Documents</div>
                <div id="attached" class="panel-body">
                    @if (!PO.AttachedDocuments || PO.AttachedDocuments.length < 1) {
                        <div>No linked documents.</div>
                    }
                    @for (Doc of PO.AttachedDocuments; track Doc) {
                        <div style="padding-top: 10px; padding-bottom: 10px">
                            <div class="col-md-8">
                                <a style="cursor: pointer" (click)="OpenFile(Doc)">
                                    <b>{{ Doc.DocumentTypeName }}&nbsp;{{ Doc.DocumentName }}</b>
                                </a>
                                <br />
                                <br />
                                <i>Archive Date: {{ Doc.DocumentArchiveDate + "Z" | date: "M/d/yyyy h:mm:ss a" }}</i>
                                <br />
                                <br />
                                <a style="cursor: pointer" (click)="OpenDoc(Doc)">View Details</a>
                                <br />
                                <span>
                                    <a style="cursor: pointer" (click)="OpenFileInline(Doc)">View Adobe PDF</a>
                                    <br />
                                </span>
                            </div>
                            <div class="col-md-4 pull-right">
                                @for (Metadata of Doc.Metadatas; track Metadata) {
                                    <span>
                                        {{ Metadata.FieldName }}:&nbsp;{{ Metadata.FieldValue }}
                                        <br />
                                    </span>
                                }
                            </div>
                            <div style="clear: both; float: none"></div>
                            <hr />
                        </div>
                    }
                </div>
            </div>

            <div class="panel panel-default">
                <div class="panel-heading">Line Items</div>
                <div class="panel-body">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th>Description</th>
                                <th>Quantity</th>
                                <th>Price</th>
                                <th>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (item of PO.LineItems; track item) {
                                <tr>
                                    <td>{{ item.Description }}</td>
                                    <td>{{ item.Quantity }}</td>
                                    <td>{{ item.Price | currency }}</td>
                                    <td>{{ item.Price * item.Quantity | currency }}</td>
                                </tr>
                            }
                            <tr style="border-top: 2px double black">
                                <td><b>TOTAL</b></td>
                                <td></td>
                                <td></td>
                                <td>
                                    <b>{{ GetLinesItemTotal() | currency }}</b>
                                </td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
